import React from "react";
import CategoryDescription from "../categoryDescription";
import Banner from "../homeBanner";
// import CategoryTopic from "../categoryTopic";
// import SectionInfoDescription from "../sectionInfoDescription";
// import SectionProduct from "../sectionProduct";
// import SectionProductDescription from "../sectionProductDescription";
import {
  SECTION_BANNER,
  SECTION_CATEGORY_DESCRIPTION,
  SECTION_CATEGORY_INFORMATION,
  SECTION_CATEGORY_INFORMATION_PAIR,
  SECTION_CATEGORY_INFORMATION_V2,
  SECTION_CATEGORY_INFORMATION_V3,
  SECTION_EVENT_IMAGES,
  // SECTION_CATEGORY_TOPIC,
  // SECTION_INFO_DESCRIPTION,
  // SECTION_PRODUCT,
  // SECTION_PRODUCT_DESCRIPTION,
  SECTION_STORE,
  SECTION_TOPIC,
} from "../../common/constant";
import Stores from "../stores";
import SectionTopic from "../sectionTopic";
import SectionCategoryInformation from "../sectionCategoryInformation";
import SectionCategoryInformationPair from "../sectionCategoryInformationPair";
import SectionCategoryInformationV2 from "../sectionCategoryInformationV2";
import SectionCategoryInformationV3 from "../sectionCategoryInformationV3";
import EventImages from "../eventImages";

const RenderSection = (props: any) => {
  const { sectionItem } = props;

  const showSection = () => {
    const sectionId = sectionItem._id.toString();

    if (SECTION_BANNER.includes(sectionId)) {
      return <Banner {...props} />;
    } else if (SECTION_CATEGORY_INFORMATION.includes(sectionId)) {
      return <SectionCategoryInformation {...props} />;
    } else if (SECTION_CATEGORY_INFORMATION_V2.includes(sectionId)) {
      return <SectionCategoryInformationV2 {...props} />;
    } else if (SECTION_CATEGORY_INFORMATION_V3.includes(sectionId)) {
      return <SectionCategoryInformationV3 {...props} />;
    } else if (SECTION_CATEGORY_INFORMATION_PAIR.includes(sectionId)) {
      return <SectionCategoryInformationPair {...props} />;
    } else if (SECTION_TOPIC.includes(sectionId)) {
      return <SectionTopic {...props} />;
    } else if (SECTION_CATEGORY_DESCRIPTION.includes(sectionId)) {
      return (
        <CategoryDescription
          {...props}
          isCategoriesParent={
            sectionId === "6062d1aa8ac7317e3e5ba8d8" ? true : false
          }
          isNeedScrollTrigger={false}
          isShowHome={true}
        />
      );
    } else if (SECTION_EVENT_IMAGES.includes(sectionId)) {
      return <EventImages {...props} />;
    } else if (SECTION_STORE.includes(sectionId)) {
      return <Stores {...props} />;
    }

    return <></>;
  };

  return showSection();
};

export default RenderSection;
